import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';
import { buildArray } from '@playbooks/utils';

import type { SkeletonCountProps } from './types';

const FilterSkeleton = ({ count = 3, className = '' }: SkeletonCountProps) => {
	// Theme
	const rootClassName = cn('flex-start', 'gap-4', 'w-full', className);

	// Render
	return (
		<div className={rootClassName}>
			{buildArray(count).map((v, i) => (
				<Skeleton className='!w-40' key={i} />
			))}
		</div>
	);
};
export { FilterSkeleton };
